import _ from 'lodash'

export const createConversionDataIfNotExists = component => {
    if (!_.has(component, 'conversionData')) {
        _.set(component, ['conversionData'], {})
    }
}
